(function (root, factory) {
  'use strict';

  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FunnyHooksEventsAnalytics = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function (root) {
  'use strict';

  var EVENT_NAMES = [
    'event_list_viewed',
    'event_detail_viewed',
    'booking_cta_clicked',
    'login_required_shown',
    'booking_modal_opened',
    'free_registration_completed',
    'paid_hold_started',
    'event_added_to_cart',
    'checkout_started',
    'booking_confirmation_viewed',
    'booking_error_shown',
    'booking_recovery_clicked',
    'my_events_viewed',
    'booking_cancelled'
  ];
  var ALLOWED_EVENTS = EVENT_NAMES.reduce(function (out, name) {
    out[name] = true;
    return out;
  }, {});
  var ALLOWED_SURFACES = ['catalogue', 'detail', 'drawer', 'booking_modal', 'cart', 'cart_drawer', 'my_events'];
  var ALLOWED_BOOKING_MODES = ['none', 'external', 'free', 'shopify_checkout'];
  var seen = {};

  function safeToken(value, maxLength) {
    var token = typeof value === 'string' ? value.trim().toLowerCase() : '';
    return token && token.length <= maxLength && /^[a-z0-9]+(?:[_-][a-z0-9]+)*$/.test(token) ? token : '';
  }

  function safeSlug(value) {
    var slug = safeToken(value, 120);
    return slug && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug) ? slug : '';
  }

  function sanitizeContext(context) {
    var source = context && typeof context === 'object' && !Array.isArray(context) ? context : {};
    var out = {};
    var slug = safeSlug(source.event_slug);
    var surface = safeToken(source.surface, 32);
    var bookingMode = safeToken(source.booking_mode, 32);
    var customerState = safeToken(source.customer_state, 64);
    var action = safeToken(source.action, 64);
    var outcome = safeToken(source.outcome, 64);
    var reason = safeToken(source.reason, 64);
    var itemCount = Number(source.item_count);

    if (slug) out.event_slug = slug;
    if (ALLOWED_SURFACES.indexOf(surface) >= 0) out.surface = surface;
    if (ALLOWED_BOOKING_MODES.indexOf(bookingMode) >= 0) out.booking_mode = bookingMode;
    if (customerState) out.customer_state = customerState;
    if (action) out.action = action;
    if (outcome) out.outcome = outcome;
    if (reason) out.reason = reason;
    if (Number.isInteger(itemCount) && itemCount >= 0 && itemCount <= 100) out.item_count = itemCount;
    return out;
  }

  function track(name, context, options) {
    var eventName = typeof name === 'string' ? name.trim() : '';
    if (!ALLOWED_EVENTS[eventName]) return null;

    var opts = options && typeof options === 'object' ? options : {};
    var dedupeKey = typeof opts.dedupeKey === 'string' ? opts.dedupeKey.slice(0, 240) : '';
    var seenKey = eventName + '|' + dedupeKey;
    if (opts.once === true && seen[seenKey]) return null;
    if (opts.once === true) seen[seenKey] = true;

    var sanitized = sanitizeContext(context);
    var detail = Object.assign({ event_name: eventName }, sanitized);
    if (root) {
      var history = Array.isArray(root.__FH_EVENTS_ANALYTICS_EVENTS__) ? root.__FH_EVENTS_ANALYTICS_EVENTS__ : [];
      history.push(detail);
      if (history.length > 100) history.splice(0, history.length - 100);
      root.__FH_EVENTS_ANALYTICS_EVENTS__ = history;

      if (Array.isArray(root.dataLayer)) {
        root.dataLayer.push(Object.assign({ event: eventName }, sanitized));
      }
      if (root.document && typeof root.CustomEvent === 'function' && typeof root.document.dispatchEvent === 'function') {
        root.document.dispatchEvent(new root.CustomEvent('fh:events:analytics', { detail: detail }));
      }
    }
    return detail;
  }

  return {
    eventNames: EVENT_NAMES.slice(),
    sanitizeContext: sanitizeContext,
    track: track
  };
});
